import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";

@Component({
  selector: 'app-select-month-range',
  templateUrl: './select-month-range.component.html',
  styleUrls: ['./select-month-range.component.scss'],
})
export class SelectMonthRangeComponent implements OnInit {

  mode: 'single' | 'range' = 'single';

  months: string[] = [];

  singleMonth?: string;

  dateFrom?: string;
  dateTo?: string;
  @Input() modalTitle: string;

  constructor(private modalController: ModalController,
              private commonUtils: CommonUtils,
              private appStateService: AppStateService) {
  }

  ngOnInit(): void {
    this.months = this.generateMonths(36);
  }

  private generateMonths(count: number): string[] {
    const result: string[] = [];
    const date = new Date();

    for (let i = 0; i < count; i++) {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      result.push(`${month}-${year}`);

      date.setMonth(date.getMonth() - 1);
    }

    return result;
  }

  private formatMonthLabel(value: string): string {
    const [monthStr, yearStr] = value.split('-');

    const monthIndex = parseInt(monthStr, 10) - 1;

    const date = new Date(Number(yearStr), monthIndex);

    return date.toLocaleString('pl-PL', {
      month: 'long',
      year: 'numeric'
    });
  }

  isRangeValid(): boolean {
    if (!this.dateFrom || !this.dateTo) return false;

    const from = this.toDate(this.dateFrom);
    const to = this.toDate(this.dateTo);

    return to >= from;
  }

  onFromChange(value: string) {
    this.dateFrom = value;

    if (this.dateTo && this.toDate(this.dateTo) < this.toDate(value)) {
      this.dateTo = undefined;
    }
  }

  getAvailableToMonths(): string[] {
    if (!this.dateFrom) return this.months;

    const from = this.toDate(this.dateFrom);

    return this.months.filter(m => this.toDate(m) >= from);
  }

  private toDate(value: string): Date {
    const [monthStr, yearStr] = value.split('-');
    return new Date(Number(yearStr), Number(monthStr) - 1);
  }


  checkButtonValidity() {
    if (this.mode === 'single') {
      if (this.singleMonth) {
        return true;
      } else {
        return false;
      }
    }
    if (this.dateFrom && this.dateTo) {
      return true;
    } else {
      return false;
    }

  }


  generateReport(): void {
    if (this.mode === 'single') {
      const from = this.singleMonth;

      if (this.singleMonth) {
        this.modalController.dismiss({
          dateFrom: from,
          dateTo: from
        });
      }
    }
    if (this.dateFrom && this.dateTo) {
      this.modalController.dismiss({
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      });
    }
  }

  onClose() {
    this.modalController.dismiss();
  }
}
